import React from 'react';
import { MultiSelectWithSearchFilter } from '@amzn/unified-data-table-components/core/components/Filter';
import { FILTERABLE_COLUMNS } from '../constants/filterableColumns';

interface FilterGroup {
  colId: string;
  filterName: string;
  filterComponent: React.ComponentType;
  filterComponentProps: Record<string, unknown>;
}

interface GtmStatusOption {
  value: string;
  label: string;
}

export const getFilterGroups = (
  brands: string[],
  slotPackages: string[],
  t: (key: string) => string,
  gtmStatusOptions?: GtmStatusOption[]
): FilterGroup[] => {
  const groups: FilterGroup[] = [];

  if (brands && brands.length > 0) {
    groups.push({
      colId: FILTERABLE_COLUMNS.BRAND,
      filterName: t('table-header-brand'),
      filterComponent: MultiSelectWithSearchFilter,
      filterComponentProps: {
        filterOptions: {
          clientSideOptionRows: brands.map(brand => ({
            rawData: brand,
            value: brand,
            label: brand,
          })),
          getOptionValue: (data: { value: string }) => data.value,
          getOptionLabel: (data: { label: string }) => data.label,
          getOptionRenderer: (data: { label: string }) => React.createElement('span', null, data.label),
          getSelectedOptionRenderer: (data: { label: string }) => React.createElement('span', null, data.label),
          getOptionQuickFilterText: (data: { label: string }) => data.label,
          pageSize: 50,
          minHeight: '18.75rem',
          maxHeight: '25rem',
          placement: 'top',
        },
        shouldAllowAddRemoveAll: true,
        popupPlacement: 'top-start',
      },
    });
  }

  groups.push({
    colId: FILTERABLE_COLUMNS.SLOT_NAMES,
    filterName: t('table-header-slot-names'),
    filterComponent: MultiSelectWithSearchFilter,
    filterComponentProps: {
      filterOptions: {
        clientSideOptionRows: slotPackages.map(pkg => ({
          rawData: pkg,
          value: pkg,
          label: pkg,
        })),
        getOptionValue: (data: { value: string }) => data.value,
        getOptionLabel: (data: { label: string }) => data.label,
        getOptionRenderer: (data: { label: string }) => React.createElement('span', null, data.label),
        getSelectedOptionRenderer: (data: { label: string }) => React.createElement('span', null, data.label),
        getOptionQuickFilterText: (data: { label: string }) => data.label,
        pageSize: 50,
        minHeight: '18.75rem',
        maxHeight: '25rem',
        placement: 'top',
      },
      shouldAllowAddRemoveAll: true,
      popupPlacement: 'top-start',
    },
  });

  if (gtmStatusOptions && gtmStatusOptions.length > 0) {
    groups.push({
      colId: FILTERABLE_COLUMNS.GTM_STATUS,
      filterName: t('table-header-gtm-status'),
      filterComponent: MultiSelectWithSearchFilter,
      filterComponentProps: {
        filterOptions: {
          clientSideOptionRows: gtmStatusOptions.map(option => ({
            rawData: option.value,
            value: option.value,
            label: option.label,
          })),
          getOptionValue: (data: { value: string }) => data.value,
          getOptionLabel: (data: { label: string }) => data.label,
          getOptionRenderer: (data: { label: string }) => React.createElement('span', null, data.label),
          getSelectedOptionRenderer: (data: { label: string }) => React.createElement('span', null, data.label),
          getOptionQuickFilterText: (data: { label: string }) => data.label,
          pageSize: 50,
          minHeight: '18.75rem',
          maxHeight: '25rem',
          placement: 'top',
        },
        shouldAllowAddRemoveAll: true,
        popupPlacement: 'top-start',
      },
    });
  }

  return groups;
};